import { connect } from 'react-redux';

import AuthNotification from './AuthNotification';

const _mapStateToProps = ({ authentication }) => ({
    authNotificationOptions: authentication.authNotificationOptions,
    launchIndependentNotifications:
        authentication.featureFlags.launchIndependentNotifications,
});

const _mapDispatchToProps = (dispatch) => ({
    handleOnClick: (actionClick) => dispatch(actionClick()),
});

export default connect(_mapStateToProps, _mapDispatchToProps)(AuthNotification);
